import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Project } from '@shared/index';
import { ToastrService } from '@shared-angular/services/toastr.service';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { ProjectService } from '../../../../../../shared/services/project.service';

@Component({
  selector: 'app-delete-project-modal',
  imports: [FormsModule, CheckboxModule, ButtonModule],
  templateUrl: './delete-project-modal.component.html',
  styleUrl: './delete-project-modal.component.css',
  standalone: true
})
export class DeleteProjectModalComponent {
  public project!: Project;
  public trashbots = false;

  constructor(public projectService: ProjectService, private bsModalRef: BsModalRef, private toastr: ToastrService) { }

  public async deleteProject() {
    try {
      await this.projectService.deleteProject(this.project._id, (this.trashbots) ? 'trashbots' : '-');
    } catch (error: unknown) {
      if ((error as { error?: { errorType?: string } }).error?.errorType === 'PROJECT_HAS_WRITE_PROTECTED_BOTS') {
        this.toastr.error('DELETED', $localize`:@@delete-project-write-protected:Dieses Projekt enthält schreibgeschützte Bots. Hebe den Schreibschutz auf, um das Projekt zu löschen.`);
        return;
      }
      throw error;
    }
    this.bsModalRef.hide();
  }
}